import { TTicketDisposal } from "../@types/data/ticket"

export const initialForm = {
  buyer: {
    name: "",
    phone: "",
    email: "",
  },
  tickets: [] as TTicketForm[],
  card: {
    number: "",
    date: "",
    code: "",
    name: "",
    cpf: "",
  },
}

export type TTicketForm = Partial<TTicketDisposal> & {
  person: {
    name: string
  }
}

export type TForm = typeof initialForm
